import { Tooltip } from 'antd'
import { TbUsers, TbUserShare } from 'react-icons/tb'

import { classNames } from '@/Ship/Helpers/classNames'

import { DISK_ROLE_LABEL } from '../Contracts/DiskShare'
import { pluralUk } from '../Helpers/diskFormat'

import type { DiskNode } from '../Contracts/DiskNode'
import type { DiskShareSummary } from '../Contracts/DiskShare'

import styles from './DiskShare.module.css'

/** «2 особи · 1 відділ · уся компанія» — кому надано доступ на самому вузлі. */
export const shareSummaryText = (summary: DiskShareSummary): string =>
    [
        summary.people > 0 ? `${summary.people} ${pluralUk(summary.people, 'особа', 'особи', 'осіб')}` : null,
        summary.departments > 0
            ? `${summary.departments} ${pluralUk(summary.departments, 'відділ', 'відділи', 'відділів')}`
            : null,
        summary.roles > 0 ? `${summary.roles} ${pluralUk(summary.roles, 'роль', 'ролі', 'ролей')}` : null,
        summary.company ? 'уся компанія' : null,
    ]
        .filter(Boolean)
        .join(' · ')

/**
 * Значки біля назви (`DISK-005` §3.6.4): «є доступи» — доступ надано на
 * самому вузлі; «спільне з вами» — вашу роль тут дав доступ, а не простір.
 * Окремої колонки немає; без значка — лише доступ простору.
 */
export const DiskNodeBadges = ({ node, hideShared = false }: { node: DiskNode; hideShared?: boolean }) => {
    const summary = node.shareSummary
    const shared = node.sharedWithMe && !hideShared

    if (summary === null && !shared) return null

    return (
        <span className={classNames(styles['badges'])}>
            {summary !== null && (
                <Tooltip title={`Доступ надано: ${shareSummaryText(summary)}`}>
                    <TbUsers aria-label="Є доступи" data-testid="disk-badge-shares" />
                </Tooltip>
            )}
            {shared && (
                <Tooltip title={`Спільне з вами${node.role ? `: ${DISK_ROLE_LABEL[node.role]}` : ''}`}>
                    <TbUserShare
                        className={classNames(styles['badgeShared'])}
                        aria-label="Спільне з вами"
                        data-testid="disk-badge-shared"
                    />
                </Tooltip>
            )}
        </span>
    )
}
